import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { Card, Table, Layout, Form, Button, Input, PageHeader } from "antd";
import dayjs from "dayjs";
import "./Users.scss";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useHistory, useLocation } from "react-router-dom";
import { UserLink } from "../../components/UserLink/UserLink";
import { DeleteOutlined } from "@ant-design/icons";
import { fmtDateTime } from "../../common/Utils";
import moment from "moment";
import { SortOrder } from "antd/lib/table/interface";
import { shareEduOfferUsersStore } from "../../store/user/ShareEduOfferUsersStore";

dayjs.extend(customParseFormat);

export const ShareEduOfferUsers = observer(() => {
  const [form] = Form.useForm();

  const store = shareEduOfferUsersStore;

  const location = useLocation();

  const history = useHistory();

  useEffect(() => {
    store.onLocation(location);
  }, []);

  useEffect(() => {
    store.onLocation(location);
  }, [location.search]);

  const onPage = (page, pageSize) => {
    store.onPage(history, page, pageSize);
  };

  const onChange = (pagination, filters, sorter, { action }) => {
    if (action === "sort") {
      store.sortedInfo = sorter;
      store.refresh();
    }
  };

  const onAdd = (values) => {
    store.addEmail(values.email).then(() => {
      form.resetFields();
    });
  };

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Full Name",
      dataIndex: "name",
      key: "firstName.keyword",
      className: "text-left",
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (_, r) => <UserLink userId={r.id} name={r.name} fullName={r.name} />,
      sortOrder: store.sortedInfo.columnKey === "firstName.keyword" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email.keyword",
      sorter: true,
      sortOrder: store.sortedInfo.columnKey === "email.keyword" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Verification Status",
      dataIndex: "state",
      key: "state",
    },
    {
      title: "Registration Time",
      dataIndex: "createDate",
      align: "center" as const,
      key: "createDate",
      sorter: (a, b) => moment(a.createDate).valueOf() - moment(b.createDate).valueOf(),
      render: (t, r) => fmtDateTime(t),
      sortOrder: store.sortedInfo.columnKey === "createDate" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "App Status",
      dataIndex: "lastActivity",
      align: "center" as const,
      key: "lastActivity",
      sorter: (a, b) => moment(a.lastActivity).valueOf() - moment(b.lastActivity).valueOf(),
      render: (t, r) => `${t ? fmtDateTime(t) : "Inactive"}`,
      sortOrder: store.sortedInfo.columnKey === "lastActivity" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "",
      key: "actions",
      render: (t, r) => <div>{<DeleteOutlined onClick={() => store.delUser(r.id)} />}</div>,
    },
  ];

  return (
    <Layout.Content>
      <PageHeader
        title="EduShare Offer Users"
        extra={
          <Button size="small" onClick={() => store.refresh()} loading={store.loading}>
            Refresh
          </Button>
        }
      />
      <div className="p-24px">
        {/* <FilterBar store={store} actionsSpan={16}>
        <Col span={8}>
          <Form.Item label="Email">
            <Input allowClear value={store.filter.email} onChange={(e) => (store.filter.email = e.target.value)} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="User Name">
            <Input allowClear value={store.filter.name} onChange={(e) => (store.filter.name = e.target.value)} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="Invitation Code or Name">
            <Input
              allowClear
              value={store.filter.invitation}
              onChange={(e) => (store.filter.invitation = e.target.value)}
            />
          </Form.Item>
        </Col>
      </FilterBar> */}

        <Card size="small" title="Add More">
          <Form form={form} layout="inline" onFinish={onAdd}>
            <Form.Item label="Email" name="email" rules={[{ required: true, type: "email" }]}>
              <Input placeholder="Enter Email" />
            </Form.Item>
            <Form.Item shouldUpdate>
              {() => (
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={store.adding}
                  disabled={
                    !form.isFieldsTouched(true) || !!form.getFieldsError().filter(({ errors }) => errors.length).length
                  }
                >
                  Submit
                </Button>
              )}
            </Form.Item>
          </Form>
        </Card>

        <Card size="small" style={{ marginTop: 20 }}>
          <Table
            onChange={onChange}
            size="small"
            pagination={{ ...store.pagination, onChange: onPage }}
            loading={store.loading}
            rowKey="id"
            columns={columns}
            dataSource={store.data.items}
          />
        </Card>
      </div>
    </Layout.Content>
  );
});
